import { formatAmounts } from '@aytm/app/stats/lib/util/helpers'

export const getErrData = (as, mode, options = {}) => {
  const { ignoreAmount, ignorePercents, rType, confidenceLevels = [] } = options
  const answerType = options.answerType || 'amount'

  let err = null
  let minErrValue = 0
  let maxErrValue = 0

  if (as.errLO !== undefined && as.errHI !== undefined) {
    err = { low: {}, high: {}, total: {} }

    const errLO = as[!(rType == null || rType === 'cases') && as.respPercents != null ? 'respErrLO' : 'errLO']
    const errHI = as[!(rType == null || rType === 'cases') && as.respPercents != null ? 'respErrHI' : 'errHI']

    for (let cli = 0; cli < confidenceLevels.length; cli++) {
      const cl = confidenceLevels[cli]
      const key = Math.round(1000 * cl[0])

      err.low[key] = {}
      if (Array.isArray(errLO)) {
        err.low[key][answerType] = Number(formatAmounts(errLO[cli][0]))
        if (!ignorePercents) err.low[key].percents = Number(errLO[cli][1])
      } else {
        err.low[key][answerType] = Number(formatAmounts(errLO[answerType][cli]))
        if (!ignorePercents) err.low[key].percents = Number(errLO.percents[cli])
      }

      err.high[key] = {}
      if (Array.isArray(errHI)) {
        err.high[key][answerType] = Number(formatAmounts(errHI[cli][0]))
        if (!ignorePercents) err.high[key].percents = Number(errHI[cli][1])
      } else {
        err.high[key][answerType] = Number(formatAmounts(errHI[answerType][cli]))
        if (!ignorePercents) err.high[key].percents = Number(errHI.percents[cli])
      }
    }

    err.total = {}
    if (!ignoreAmount) err.total[answerType] = as[answerType]
    if (!ignorePercents) {
      err.total.percents =
        as[!(rType == null || rType === 'cases') && as.respPercents != null ? 'respPercents' : 'percents'] || 0
    }

    if (Object.keys(err.low).length) {
      minErrValue = Math.max.apply(
        Math,
        Object.keys(err.low).map(key => err.low[key][mode])
      )
    }
    if (Object.keys(err.high).length) {
      maxErrValue = Math.max.apply(
        Math,
        Object.keys(err.high).map(key => err.high[key][mode])
      )
    }
  }

  return { err, minErrValue, maxErrValue }
}

export const getConfidenceInterval = (point, percentDecimals, options = {}) => {
  const { qType, viewMode, answerType: _answerType, ignorePercents, confidenceLevel, axisType } = options

  const conf = String(1000 * confidenceLevel)
  const answerType = _answerType || 'amount'

  if (point.errData.err.low[conf] == null || point.errData.err.high[conf] == null) {
    return
  }

  let low, high, isPercents

  if (qType === 'md') {
    isPercents = viewMode === 'varyingProbability' || viewMode === 'probability'

    low = formatAmounts(
      point.errData.err.total[answerType] - point.errData.err.low[conf][answerType],
      null,
      isPercents ? percentDecimals : 2,
      isPercents
    )
    high = formatAmounts(
      point.errData.err.total[answerType] + point.errData.err.high[conf][answerType],
      null,
      isPercents ? percentDecimals : 2,
      isPercents
    )
  } else {
    const percentsMode = axisType ? axisType === 'percents' : !ignorePercents

    if (percentsMode) {
      isPercents = true
      // strict, so an end that rounds to a whole number keeps the decimals its partner carries
      low = formatAmounts(
        point.errData.err.total.percents - point.errData.err.low[conf].percents,
        null,
        percentDecimals,
        true
      )
      high = formatAmounts(
        point.errData.err.total.percents + point.errData.err.high[conf].percents,
        null,
        percentDecimals,
        true
      )
    } else {
      low = formatAmounts(point.errData.err.total[answerType] - point.errData.err.low[conf][answerType])
      high = formatAmounts(point.errData.err.total[answerType] + point.errData.err.high[conf][answerType])
    }
  }

  const pct = isPercents ? '%' : ''
  return `${low}${pct} - ${high}${pct}`
}
